import React from 'react';
import { Redirect, Switch, Route } from 'react-router-dom';
import IM from '@/pages/im/Container';
import DefaultPage from '@/pages/Default';
import ErrorPage from '@/pages/Error';
import Test from '@/pages/test';
import RouteWrapper from './RouteWrapper';

function RouteSwitch(): JSX.Element {
    return (
        <Switch>
            <RouteWrapper path="/:platform/:game_key" component={IM} />
            <Route path="/error" component={ErrorPage} />
            <Route path="/test" component={Test} />
            <Route path="/" component={DefaultPage} />
            <Redirect from="/" to="/" />
        </Switch>
    );
}

export default RouteSwitch;
